import { Palette } from 'lucide-react';
import { setUiTheme, nextUiTheme, UI_THEMES } from './uiTheme';

export default function ThemeToggle({ theme, onChange, compact = false }) {
  const next = nextUiTheme(theme);
  const currentLabel = UI_THEMES[theme]?.label || theme;
  const nextLabel = UI_THEMES[next].label;
  const title = `Theme: ${currentLabel}. Switch to ${nextLabel}.`;

  return (
    <button
      type="button"
      onClick={() => {
        setUiTheme(next);
        onChange?.(next);
      }}
      className={compact ? 'nav-sidebar-item' : 'btn-secondary w-full py-2 text-xs'}
      title={title}
      aria-label={title}
    >
      <Palette className="h-4 w-4 shrink-0" />
      {!compact && `Theme: ${currentLabel}`}
    </button>
  );
}
